import "./Table.scss";
import EsfirusTable from "@components/ui/Table/EsfirusTable";
import checkIcon from "@assets/svgs/check.svg";
import confirmedIcon from "@assets/images/lock.png";
import closeIcon from "@assets/svgs/close.svg";
import { rolesSupervisor } from "@helpers/constants";
import { EsfirusTablePropsPagination, HandleChangePaginationType } from "@services/hooks/useHandlerPaginationTable";
import PrintIcon from "@mui/icons-material/Print";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Alert, CircularProgress, Modal, Snackbar } from "@mui/material";
import { partesService } from "@services/partes";
import { useState } from "react";
import EsfirusButtonNative from "@components/ui/Button/EsfirusButtonNative";
import EsfirusTextInput from "@ui/Text-input/EsfirusTextInput";

export default function EsfirusPartesTable(props: EsfirusPartesTableProps) {
  const { pagination, totalItems, handleChangePagination, onRefresh } = props;
  const [publishingId, setPublishingId] = useState<any>(null);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: "success" | "error" }>({ open: false, message: "", severity: "success" });
  const [confirmDialog, setConfirmDialog] = useState<{ open: boolean; row: any }>({ open: false, row: null });
  const [emailInput, setEmailInput] = useState("");

  const openConfirmDialog = (row: any) => {
    setEmailInput("");
    setConfirmDialog({ open: true, row });
  };

  const handleConfirmPublishAndSign = async () => {
    const row = confirmDialog.row;
    setConfirmDialog({ open: false, row: null });
    setPublishingId(row.id);
    try {
      const response: any = await partesService.publishAndSign(String(row.id), emailInput || undefined);
      setSnackbar({ open: true, message: emailInput ? "Parte publicado, PDF firmado generado y enviado por email." : "Parte publicado y PDF firmado generado correctamente.", severity: "success" });
      if (onRefresh) onRefresh();

      const responseData = response?.data?.data;
      const base64Data = responseData?.Base64File || responseData?.pdf || responseData?.file || responseData?.base64 || responseData?.FileBase64 || responseData?.pdfBase64;
      if (base64Data) {
        const linkSource = `data:application/pdf;base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        const fileName = responseData?.FileName || `parte_firmado_${row.id}.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    } catch (err: any) {
      const msg = err?.response?.data?.message || err?.message || "Error al publicar y firmar el parte.";
      setSnackbar({ open: true, message: msg, severity: "error" });
    } finally {
      setPublishingId(null);
    }
  };

  const columns = [
    {
      name: "Empresa - Nº Parte",
      keymap: "_id",
      see: true,
      order: true,
      orderKeymap: "id",
      width: 150,
      actions: [
        {
          handle: (row: any) => openConfirmDialog(row),
          title: (row: any) => row.firma && row.tipo === 'A' ? "Publicar y generar PDF firmado" : "",
          icon: (row: any) => {
            if (!row.firma || row.validado === 2) return <></>;
            if (publishingId == row.id) return <CircularProgress size={16} />;
            return <PrintIcon className="filter-blue" />;
          },
          disabled: (row: any) => !row.firma || row.tipo !== 'A' || publishingId == row.id,
        }
      ]
    },
    {
      name: "Fecha",
      keymap: "date",
      parse: (d: number) =>
        new Intl.DateTimeFormat('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).format(new Date(d)),
      order: true,
      width: 90
    },
    {
      name: "T",
      keymap: "tipo",
      order: true,
      width: 20
    },
    {
      name: "Nº y Desc. Obra",
      keymap: "nombreObra2",
      order: true,
      orderKeymap: "nombreObra",
      width: 250
    },
    {
      name: "Empleado",
      keymap: "nombre_empleado",
      order: true,
      width: 150

    },
    {
      name: "Horario",
      keymap: "horaInicioFin",
      order: false,
      parse: (d: any, row: any) => {
        return <p>{row.horaInicio}<br />{row.horaFin}</p>
      },
      width: 60
    },
    //  {
    //   name: "Hora Inicio",
    //   keymap: "horaInicio",
    //   order: false,
    //   width: 60
    // },
    // {
    //   name: "Hora Fin",
    //   keymap: "horaFin",
    //   order: false,
    //   width: 60
    // },
    {
      name: "Horas",
      keymap: "horas",
      order: true,
      width: 60
    },
    {
      name: "Imp.",
      keymap: "importe",
      parse: (d: any) => {
        return d ? Number(d).toFixed(2).replace(".00", "").replace(".", ",") + "€" : "";
      },
      order: true,
      width: 50
    },
    {
      name: "Estado",
      keymap: "validadoImg",
      width: 60
    }
  ];

  const parseRows = (rows: any) => {
    return rows.map((el: any) => {
      const empresa: any = props.empresas?.find((e: any) => e.Empresa == el.empresa);
      return {
        ...el,
        validadoImg: setValidation(el.validado),
        _id: (empresa?.Nombre ?? el.empresa) + "-" + el.id,
        nombreObra2: `${el?.idObra} - ${el.nombreObra}`,

      };
    });
  };

  const setValidation = (type: number) => {

    const icons: any = {
      0: { icon: "", class: "", type },
      1: { icon: confirmedIcon, class: "confimed-icon", type },
      2: { icon: checkIcon, class: "validated-icon", type },
      3: { icon: closeIcon, class: "rejected-icon", type },
    };
    // return type
    return icons[type];
  };

  return (
    <>
      <EsfirusTable
        rows={parseRows(props?.partes)}
        deleteReport={props?.deleteReport}
        columns={columns}
        rowsCount={totalItems}
        pagination={pagination}
        customPageSizes={[10, 25, 50, 100]}
        withPagination={true}
        handleChangePagination={handleChangePagination}
        tableId={props.tableId}
        loading={props.loading}
      >
        {props.children}
      </EsfirusTable>

      <Modal
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, row: null })}
      >
        <div style={{ color: '#075577', position: 'absolute', top: '50%', left: '50%', width: 'max(340px, 40%)', maxWidth: 500, backgroundColor: 'white', borderRadius: 25, transform: 'translate(-50%, -50%)', outline: 'none' }}>
          <div style={{ backgroundColor: '#82d08e', borderRadius: '25px 25px 0 0', padding: '20px 24px' }}>
            <h5 style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#075577', margin: 0, fontSize: 16, fontWeight: 600 }}>
              <PrintIcon style={{ fontSize: 22, color: '#075577' }} />
              Publicar y generar PDF firmado
            </h5>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, padding: '24px 32px 28px' }}>
            <p style={{ margin: 0, fontSize: 15, color: '#075577' }}>El parte se publicará en el ERP y se generará el PDF con la firma incrustada.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 600, color: '#075577' }}>
                <EmailOutlinedIcon style={{ fontSize: 18 }} />
                Enviar por email (opcional)
              </label>
              <EsfirusTextInput
                type="email"
                placeholder="correo@ejemplo.com"
                value={emailInput || ''}
                onChange={(e: any) => setEmailInput(e.target.value)}
                fullWidth
              />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 8 }}>
              <div style={{ width: 140 }}>
                <EsfirusButtonNative click={handleConfirmPublishAndSign} label="Confirmar" />
              </div>
              <div style={{ width: 140 }}>
                <EsfirusButtonNative click={() => setConfirmDialog({ open: false, row: null })} label="Cancelar" className="secondary" />
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export interface EsfirusPartesTablePropsOption {
  label: string;
  value: any;
}

export interface EsfirusPartesTableProps {
  partes?: [];
  rol?: number;
  empresas?: [];
  deleteReport?: (id: string) => void;
  pagination?: EsfirusTablePropsPagination
  totalItems?: number
  handleChangePagination?: HandleChangePaginationType
  tableId: string;
  children?: React.ReactNode;
  loading?: boolean;
  onRefresh?: () => void;
}
